// extracted by mini-css-extract-plugin
export default {"wrapper":"hero-header-module__wrapper___HGLnm"};